import { LegalPage } from "./legal/LegalPage";
import CookiesDocument from "./dynamic/Cookies";

export default function CookiesComponent() {
  return (
    <LegalPage path="/cookies">
      <CookiesDocument />
    </LegalPage>
  );
}
